import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import KYC from "../CustomerDetails/KYC/KYC";
import AgentTransfers from "../AgentTransfersTabs/AgentTransfers";
import AgentTransaction from "../AgentTransfersTabs/AgentTransaction";
import AgentFilters from "../AgentTransfersTabs/AgentFilter";
import AgentFees from "../AgentTransfersTabs/AgentFees";
import FraudRules from "../AgentTransfersTabs/FraudRules";
import AgentOrg from "../AgentTransfersTabs/AgentOrg";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        overflow: "auto",
      }}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AgentAccountTabs({
  selectedUser,
  selectedUserData,
  setSelectedUserData,
}) {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(0);
  }, [selectedUser]);


  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "capitalize",
              color: "#BCBCBC",
              fontFamily: "Inter",
              fontSize: 15,
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "30px",
              backgroundColor: "#f8f8f8",
              "&.Mui-selected": {
                backgroundColor: "white",
                color: "#5523D2",
                borderRadius: "6px 6px 0 0 !important",
                textAlign: "center",
                fontSize: 15,
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "30px",
                borderBottom: 0,
                borderBottomColor: "#FAC800",
                borderBottomWidth: 4,
              },
            },
          }}
        >
          <Tab
            label="Transfers"
            {...a11yProps(0)}
            //disabled={selectedUserData === null}
          />
          <Tab
            label="Transactions"
            {...a11yProps(1)}
            //disabled={selectedUserData === null}
          />
          {/* <Tab
            label="Subagents"
            {...a11yProps(2)}
            //disabled={selectedUserData === null}
          /> */}
          <Tab
            label="Fees"
            {...a11yProps(2)}
            //disabled={selectedUserData === null}
          />
          <Tab
            label="Rules / Filters"
            {...a11yProps(3)}
            //disabled={selectedUserData === null}
          />
          <Tab
            label="Fraud Rules"
            {...a11yProps(4)}
            //disabled={selectedUserData === null}
          />
          <Tab
            label="Org"
            {...a11yProps(5)}
            //disabled={selectedUserData === null}
          />
          <Tab
            label="KYC/KYB"
            {...a11yProps(6)}
            // disabled={selectedUserData === null}
          />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <AgentTransfers
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <AgentTransaction
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <AgentFees
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <AgentFilters
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={4}>
        <FraudRules
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={5}>
        <AgentOrg
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={6}>
        <KYC
          selectedUser={selectedUser}
          selectedUserData={selectedUserData}
          setSelectedUserData={setSelectedUserData}
        />
      </CustomTabPanel>
    </Box>
  );
}
